import { AccessCodes } from './typings.access-codes.js';

const USER_AREA_BASE_PATH = "/brugeromraade";
const userAreaRootDescriptor = {
  id: "user-area",
  path: "/brugeromraade",
  title: "Brugeromr\xE5de",
  description: void 0,
  accessCode: AccessCodes.ALLOWED,
  type: "UserArea",
  megaMenu: {
    hasMegaMenu: false,
    terminateMegaMenu: true,
    showGradeFilters: false,
    displayType: {},
    allFiltersSelectorText: ""
  },
  clientside: true,
  hidden: true,
  hasChildren: true,
  hasResources: false,
  children: [
    makeUserAreaPageDescriptor("fagportaler", "Fagportaler"),
    makeUserAreaPageDescriptor("favoritter", "Favoritter"),
    makeUserAreaPageDescriptor("besvarelser", "Besvarelser"),
    makeUserAreaPageDescriptor("forloeb", "Mine forl\xF8b"),
    makeUserAreaPageDescriptor("hold", "Mine hold"),
    makeUserAreaPageDescriptor("oplaesning", "Indstil opl\xE6sning"),
    makeUserAreaPageDescriptor("skrifttype", "Indstil skrifttype"),
    makeUserAreaPageDescriptor("teknisk-support", "Teknisk support")
  ]
};
function makeUserAreaPageDescriptor(slug, title) {
  return {
    id: `user-area.${slug}`,
    parentId: "user-area",
    type: "UserArea",
    path: `${USER_AREA_BASE_PATH}/${slug}`,
    title,
    description: void 0,
    accessCode: AccessCodes.ALLOWED,
    clientside: true,
    megaMenu: {
      hasMegaMenu: false,
      terminateMegaMenu: true,
      showGradeFilters: false,
      displayType: {},
      allFiltersSelectorText: ""
    },
    hasChildren: false,
    hasResources: false
  };
}

export { USER_AREA_BASE_PATH, userAreaRootDescriptor };
//# sourceMappingURL=descriptor.user-area.js.map
